import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api.js';

const URL = `${process.env.REACT_APP_API_URL}/api/appuntiDemo2`;

export const fetchNotes = createAsyncThunk(
  'notes/fetchNotes',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get(URL);
      return res.data.appunti || [];
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'error loading notes');
    }
  }
);


export const addNote = createAsyncThunk(
  'notes/addNote',
  async (note, { rejectWithValue }) => {
    try {
      const res = await api.post(URL, note);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'error adding note');
    }
  }
);


export const updateNote = createAsyncThunk(
  'notes/updateNote',
  async (note, { rejectWithValue }) => {
    try {
      const { id, nome, descrizione, categoria } = note;
      const res = await api.put(`${URL}/${id}`, { nome, descrizione, categoria });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'error updating note');
    }
  }
);


export const deleteNote = createAsyncThunk(
  'notes/deleteNote',
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`${URL}/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'error deleting note');
    }
  }
);


const notesSlice = createSlice({
  name: 'notes',
  initialState: {
    list: [],
    currentPage: 1,
    isLoading: false,
    error: null,
  },
  reducers: {
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchNotes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchNotes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // add
      .addCase(addNote.fulfilled, (state, action) => {
        state.list.push(action.payload);
      })
      .addCase(addNote.rejected, (state, action) => {
        state.error = action.payload;
      })

      // edit
      .addCase(updateNote.fulfilled, (state, action) => {
        const index = state.list.findIndex((item) => item.id === action.payload.id);
        if (index !== -1) state.list[index] = action.payload;
      })
      .addCase(updateNote.rejected, (state, action) => {
        state.error = action.payload;
      })

      // delete
      .addCase(deleteNote.fulfilled, (state, action) => {
        state.list = state.list.filter((item) => item.id !== action.payload);
      })
      .addCase(deleteNote.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, clearError } = notesSlice.actions;
export default notesSlice.reducer;
